import React, { useState, useEffect } from "react";
import { reviews as reviewsFallback } from "./homeData/reviews";
import configService from "../../../services/configService";

export default function Testimonials() {
  const [reviews, setReviews] = useState(reviewsFallback);
  const [submitted,   setSubmitted]   = React.useState(false);
  const [hoveredStar, setHoveredStar] = React.useState(0);
  const [form,        setForm]        = React.useState({ firstName: "", lastName: "", service: "", rating: 0, text: "" });
  const [errors,      setErrors]      = React.useState({});
  const [userReviews, setUserReviews] = React.useState([]);

  useEffect(() => {
    configService.getConfig().then(r => {
      if (r.data?.reviews) setReviews(r.data.reviews);
    }).catch(() => {});
  }, []);

  const avatarGradients = [
    "linear-gradient(135deg,#002236,#003a5c)",
    "linear-gradient(135deg,#003a5c,#b45309)",
    "linear-gradient(135deg,#0d9488,#002236)",
    "linear-gradient(135deg,#6d28d9,#002236)",
    "linear-gradient(135deg,#b45309,#92400e)",
  ];

  const validate = () => {
    const e = {};
    if (!form.firstName.trim())    e.firstName = "First name is required";
    if (!form.lastName.trim())     e.lastName  = "Last name is required";
    if (!form.service.trim())      e.service   = "Service is required";
    if (!form.rating)              e.rating    = "Please select a star rating";
    if (form.text.trim().length < 20) e.text = "Please write at least 20 characters";
    return e;
  };

  const handleSubmit = () => {
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }
    setUserReviews(prev => [{
      name:    `${form.firstName.trim()} ${form.lastName.trim()}`,
      service: form.service.trim(),
      rating:  form.rating,
      text:    form.text.trim(),
      avatar:  form.firstName.trim()[0].toUpperCase(),
      isNew:   true,
    }, ...prev]);
    setSubmitted(true);
  };

  const handleReset = () => {
    setForm({ firstName: "", lastName: "", service: "", rating: 0, text: "" });
    setErrors({});
    setSubmitted(false);
  };

  const allReviews   = [...userReviews, ...reviews];
  const [ratingFilter, setRatingFilter] = React.useState(0);
  const filteredReviews = ratingFilter === 0 ? allReviews : allReviews.filter(r => r.rating === ratingFilter);
  const [visibleReviews, setVisibleReviews] = React.useState(3);
  const shownReviews = filteredReviews.slice(0, visibleReviews);

  const handleFilterChange = (rating) => {
    setRatingFilter(rating);
    setVisibleReviews(3);
  };

  return (
    <section className="home-testi">
      <div className="home-testi__bg" aria-hidden="true">
        <div className="home-testi__orb home-testi__orb--1"/>
        <div className="home-testi__orb home-testi__orb--2"/>
        <div className="home-testi__orb home-testi__orb--3"/>
        <div className="home-testi__grid"/>
        <span className="home-testi__deco home-testi__deco--1">"</span>
        <span className="home-testi__deco home-testi__deco--2">"</span>
        <span className="home-testi__deco home-testi__deco--3">★</span>
      </div>

      <div className="home-testi__inner">

        <div className="home-testi__head" data-aos="fade-down">
          <h2 className="home-testi__title">Trusted by  travellers</h2>
          {/* <span className="home-testi__title-accent">180,000+</span> */}
          <p className="home-testi__sub">Real people. Real visas. Real stories.</p>

          <div className="home-testi__aggregate">
            <div className="home-testi__stars-row">
              {[1,2,3,4,5].map(s => (
                <svg key={s} width="18" height="18" viewBox="0 0 24 24" fill="#f59e0b">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                </svg>
              ))}
            </div>
            <span className="home-testi__aggregate-score">4.9</span>
            <span className="home-testi__aggregate-count">from 12,400+ reviews</span>
          </div>
        </div>

        <div className="home-testi__two-grid">

          <div className="home-testi__grid-left">
            {/* FEEDBACK FORM */}
            <div className="home-feedback" data-aos="fade-up" data-aos-delay="100">

              <div className="home-feedback__left" data-aos="fade-right" data-aos-delay="150">
                {/* <span className="home-sec-tag home-sec-tag--dark">
                  Share Your Experience
                </span> */}
                <h3 className="home-feedback__title">How was your visa journey?</h3>
                <p className="home-feedback__desc">
                  Your review helps thousands of other travellers make the right choice.
                  It takes less than a minute.
                </p>
              </div>

              <div className="home-feedback__right" data-aos="fade-left" data-aos-delay="220">
                {submitted ? (
                  <div className="home-feedback__success">
                    <div className="home-feedback__success-icon">
                      <svg width="32" height="32" viewBox="0 0 24 24" fill="none"
                        stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M22 11.08V12a10 10 0 11-5.93-9.14"/>
                        <polyline points="22 4 12 14.01 9 11.01"/>
                      </svg>
                    </div>
                    <h4 className="home-feedback__success-title">Thank you for your review!</h4>
                    <p className="home-feedback__success-sub">Your feedback has been added above and helps other travellers.</p>
                    <button className="home-feedback__submit home-feedback__submit--ghost" onClick={handleReset}>
                      Write another review
                    </button>
                  </div>
                ) : (
                  <div className="home-feedback__form">

                    <div className="home-feedback__row">
                      <div className="home-feedback__field">
                        <label className="home-feedback__label" htmlFor="feedback-first-name">First Name</label>
                        <input
                          id="feedback-first-name"
                          name="feedback-first-name"
                          className={`home-feedback__input${errors.firstName ? " home-feedback__input--err" : ""}`}
                          placeholder="e.g. Priya"
                          value={form.firstName}
                          onChange={e => { setForm(p => ({ ...p, firstName: e.target.value })); setErrors(p => ({ ...p, firstName: "" })); }}
                        />
                        {errors.firstName && <span className="home-feedback__err">{errors.firstName}</span>}
                      </div>
                      <div className="home-feedback__field">
                        <label className="home-feedback__label" htmlFor="feedback-last-name">Last Name</label>
                        <input
                          id="feedback-last-name"
                          name="feedback-last-name"
                          className={`home-feedback__input${errors.lastName ? " home-feedback__input--err" : ""}`}
                          placeholder="e.g. Sharma"
                          value={form.lastName}
                          onChange={e => { setForm(p => ({ ...p, lastName: e.target.value })); setErrors(p => ({ ...p, lastName: "" })); }}
                        />
                        {errors.lastName && <span className="home-feedback__err">{errors.lastName}</span>}
                      </div>
                    </div>

                    <div className="home-feedback__field">
                      <label className="home-feedback__label" htmlFor="feedback-service">Service</label>
                      <input
                        id="feedback-service"
                        name="feedback-service"
                        className={`home-feedback__input${errors.service ? " home-feedback__input--err" : ""}`}
                        placeholder="e.g. Tourist Visa"
                        value={form.service}
                        onChange={e => { setForm(p => ({ ...p, service: e.target.value })); setErrors(p => ({ ...p, service: "" })); }}
                      />
                      {errors.service && <span className="home-feedback__err">{errors.service}</span>}
                    </div>

                    <div className="home-feedback__field">
                      <label className="home-feedback__label">Your Rating</label>
                      <div className="home-feedback__stars">
                        {[1,2,3,4,5].map(s => (
                          <button
                            key={s}
                            type="button"
                            className={`home-feedback__star-btn ${s <= (hoveredStar || form.rating) ? "home-feedback__star-btn--active" : ""}`}
                            onMouseEnter={() => setHoveredStar(s)}
                            onMouseLeave={() => setHoveredStar(0)}
                            onClick={() => { setForm(p => ({ ...p, rating: s })); setErrors(p => ({ ...p, rating: "" })); }}
                            aria-label={`Rate ${s} star${s > 1 ? "s" : ""}`}
                          >
                            <svg width="32" height="32" viewBox="0 0 24 24"
                              fill={s <= (hoveredStar || form.rating) ? "#f59e0b" : "none"}
                              stroke={s <= (hoveredStar || form.rating) ? "#f59e0b" : "#d4dde6"}
                              strokeWidth="1.8"
                              className={`home-testi__star ${s <= (hoveredStar || form.rating) ? "home-testi__star--active" : ""}`}
                            >
                              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                            </svg>
                          </button>
                        ))}
                        {form.rating > 0 && (
                          <span className="home-feedback__rating-label">
                            {["", "Poor", "Fair", "Good", "Great", "Excellent!"][form.rating]}
                          </span>
                        )}
                      </div>
                      {errors.rating && <span className="home-feedback__err">{errors.rating}</span>}
                    </div>

                    <div className="home-feedback__field">
                      <label className="home-feedback__label" htmlFor="feedback-text">Your Review</label>
                      <textarea
                        id="feedback-text"
                        name="feedback-text"
                        className={`home-feedback__textarea${errors.text ? " home-feedback__input--err" : ""}`}
                        placeholder="Tell us about your visa experience — the process, speed, support…"
                        rows={4}
                        value={form.text}
                        onChange={e => { setForm(p => ({ ...p, text: e.target.value })); setErrors(p => ({ ...p, text: "" })); }}
                      />
                      <div className="home-feedback__char">
                        <span>{errors.text ? <span className="home-feedback__err">{errors.text}</span> : ""}</span>
                        <span className="home-feedback__char-count" style={{ "--char-color": form.text.length < 20 ? "#94a3b8" : "#16a34a" }}>
                          {form.text.length} / 20+ chars
                        </span>
                      </div>
                    </div>

                    <button className="home-feedback__submit" onClick={handleSubmit}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="22" y1="2" x2="11" y2="13"/>
                        <polygon points="22 2 15 22 11 13 2 9 22 2"/>
                      </svg>
                      Submit Review
                    </button>

                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="home-testi__grid-right">
            <div className="home-testi__filter-bar">
              {[
                { label: "All", value: 0 },
                { label: "5 Star", value: 5 },
                { label: "4 Star", value: 4 },
                { label: "3 Star", value: 3 },
              ].map(f => (
                <button
                  key={f.value}
                  className={`home-testi__filter-btn${ratingFilter === f.value ? " home-testi__filter-btn--active" : ""}`}
                  onClick={() => handleFilterChange(f.value)}
                >
                  {f.label}
                </button>
              ))}
            </div>
            <div className="home-testi__grid-reviews">
              {shownReviews.map((r, i) => (
                <div
                  key={i}
                  className={`home-testi__card${r.isNew ? " home-testi__card--new" : ""}`}
                >
                  <span className="home-testi__card-watermark">"</span>

                  <div className="home-testi__card-stars">
                    {[1,2,3,4,5].map(s => (
                      <svg key={s} width="13" height="13" viewBox="0 0 24 24"
                        fill={s <= r.rating ? "#f59e0b" : "#d4dde6"}>
                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                      </svg>
                    ))}
                    {r.isNew && <span className="home-testi__card-new-badge">New</span>}
                  </div>

                  <p className="home-testi__card-text">"{r.text}"</p>

                  <div className="home-testi__card-author">
                    <div className="home-testi__card-avatar" style={{ "--avatar-grad": avatarGradients[i % avatarGradients.length] }}>
                      {r.avatar}
                    </div>
                    <div>
                      <div className="home-testi__card-name">{r.name}</div>
                      <div className="home-testi__card-route">
                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" strokeWidth="2">
                          <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
                          <circle cx="12" cy="9" r="2.5"/>
                        </svg>
                        {r.service || r.country}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {filteredReviews.length > 3 && (
              <div className="home-view-more-wrap">
                <button
                  className="home-view-more-btn"
                  onClick={() => setVisibleReviews(v => v < filteredReviews.length ? Math.min(v + 3, filteredReviews.length) : 3)}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points={visibleReviews >= filteredReviews.length ? "18 15 12 9 6 15" : "6 9 12 15 18 9"} />
                  </svg>
                  {visibleReviews >= filteredReviews.length
                    ? "Show Less"
                    : `View More Reviews (${filteredReviews.length - visibleReviews} remaining)`}
                </button>
              </div>
            )}
          </div>

        </div>

      </div>
    </section>
  );
}
